import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import AsaLogo from "../components/AsaLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
    } catch {
      /* Intentionally ignore — never reveal whether the account exists */
    }
    setSent(true);
    setLoading(false);
  };

  const field = "w-full h-12 pl-11 pr-4 rounded-lg border border-slate-200 text-[15px] outline-none focus:border-[#0d9488] transition-colors";

  return (
    <div className="min-h-screen bg-[#f4f8f7] flex flex-col items-center justify-center px-4">
      <button onClick={() => navigate("/asa/login")} data-testid="forgot-back-btn" className="absolute top-6 left-6 inline-flex items-center gap-1.5 text-slate-500 text-sm hover:text-slate-700"><ArrowLeft size={16} /> Back to log in</button>
      <div className="mb-8"><AsaLogo size={38} /></div>
      <div className="w-full max-w-[440px] bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <CheckCircle2 size={44} className="text-[#22a35a] mx-auto" />
            <h1 className="font-head font-bold text-slate-800 text-xl mt-4">Check your email</h1>
            <p className="text-slate-500 text-sm mt-2 leading-relaxed">If an account exists for <span className="font-medium text-slate-700">{email}</span>, we've sent a link to reset your password. It expires in 45 minutes. Don't forget to check your spam folder.</p>
            <button onClick={() => navigate("/asa/login")} className="w-full h-12 mt-6 rounded-lg bg-[#0d9488] hover:bg-[#0f766e] text-white font-semibold transition-colors">Back to log in</button>
          </div>
        ) : (
          <>
            <h1 className="font-head font-bold text-slate-800 text-2xl text-center">Forgot your password?</h1>
            <p className="text-center text-slate-500 text-sm mt-1 mb-6">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="relative">
                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={19} />
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" className={field} data-testid="forgot-email-input" />
              </div>
              <button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="w-full h-12 rounded-lg bg-[#0d9488] hover:bg-[#0f766e] disabled:opacity-60 text-white font-semibold transition-colors">{loading ? "Sending…" : "Send reset link"}</button>
            </form>
            <p className="text-center text-sm text-slate-500 mt-6">Remembered it? <button onClick={() => navigate("/asa/login")} className="text-[#0d9488] font-semibold hover:underline">Log in</button></p>
          </>
        )}
      </div>
      <p className="text-[12px] text-slate-400 mt-6">© {new Date().getFullYear()} ASA Foundation · Copyright &amp; IP: Asal Shirazi</p>
    </div>
  );
}
